import { createContext } from 'react';

const DeviceContext = createContext(false);

export default DeviceContext;
